import { useCallback, useEffect, useRef, useState } from "react";
import type { MouseEvent } from "react";
import type { OverlayPanel } from "primereact/overlaypanel";

import { HOVER_CARD_CLOSE_DELAY_MS } from "./user-info-card.constants";
import type { UserInfoCardProps, UserInfoCardViewModel } from "./types-user-info-card";

/**
 * Cartão aberto no `onMouseEnter` do gatilho e fechado com um atraso no `onMouseLeave`, para o cursor chegar a ele.
 * A foto só é buscada depois da 1ª abertura.
 */
export function useUserInfoCard({
  nome,
  email,
  telefone,
  detalhe,
  fotoUrl,
  fotoPath,
  testIds,
  children,
}: UserInfoCardProps): UserInfoCardViewModel {
  const panelRef = useRef<OverlayPanel>(null);
  const closeTimer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const [opened, setOpened] = useState(false);

  useEffect(() => () => clearTimeout(closeTimer.current), []);

  const manterAberto = useCallback(() => clearTimeout(closeTimer.current), []);

  const agendarFechamento = useCallback(() => {
    closeTimer.current = setTimeout(() => panelRef.current?.hide(), HOVER_CARD_CLOSE_DELAY_MS);
  }, []);

  function abrir(event: MouseEvent<HTMLSpanElement>) {
    manterAberto();
    setOpened(true);
    panelRef.current?.show(event, event.currentTarget);
  }

  return {
    panelRef,
    children,
    triggerTestId: testIds?.trigger,
    card: {
      nome,
      email,
      telefone,
      detalhe,
      fotoUrl,
      fotoPath,
      buscarFoto: opened,
      testIds: testIds ? { root: testIds.card, copy: testIds.copy } : undefined,
      onMouseEnter: manterAberto,
      onMouseLeave: agendarFechamento,
    },
    abrir,
    agendarFechamento,
    manterAberto,
  };
}
